import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1a103a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "登录账号", -1))
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dengluyemianyonghuming" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-weibiaoti--" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登录")

import {
  Form, Input, Button, message,
} from 'ant-design-vue';
import { ValidateErrorEntity, } from 'ant-design-vue/es/form/interface';
import { serverIp, assetsImg, } from '@/configs/index';
import { updateIconsConfig, } from '@/utils/AMapNew/icons';
import {
  ref,reactive, computed,
} from 'vue';
import { useRouter, } from 'vue-router';
import { useStore, } from 'vuex';

import screenfull from 'screenfull';
import axios from 'axios';
import moment from 'moment';
import { postRequest, } from '@/request/request';
import { stringify, } from 'qs';
import { md5Password, } from '@/utils/index';

interface FormState {
  tel: string;
  password: string;
  code: string;
  loginType: number;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { sysConfig, } = window as any;

const { Item, } = Form;
const { Password, } = Input;

const store = useStore();

const change = () => {
  store.dispatch('login/getVerification', {
    xhrFields: {
      withCredentials: true,
    },
  });
};

change();

const verificationImg = computed(() => store.state.login.verification);

const checked = ref<boolean>();
const formRef = ref();
const formState = reactive<FormState>({
  tel: '',
  password: '',
  code: '1',
  loginType: 1,
});

const phoneReg = /^1[3456789]\d{9}$|[a-z]/;

const router = useRouter();

const rules = {
  tel: [{
    required: true,message: '请输入用户名', trigger: 'blur',
  },
  {
    pattern: phoneReg, message: '请输入正确的用户名', trigger: 'blur',
  },],
  password: [{ required: true,message: '请输入密码', trigger: 'blur', },
    {
      min: 5, max: 12, message: '密码长度为5到12个字符', trigger: 'blur',
    },],
  // code: [{ required: true,message: '请输入验证码', trigger: 'blur', },],
};

const fullScreen = () => {
  if (!screenfull.isEnabled) {
    return false;
  }
  screenfull.toggle();
};

/**
 * 验证登录
 * @return {void}
 */
const onSubmit = () => {
  formRef.value
    .validate()
    .then(() => {
      const params = {
        tel: formState.tel,
        password: md5Password(formState.password, formState.tel),
        code: formState.code,
        loginType: formState.loginType,
      };
      // axios.post(`${serverIp}/login`,formState).then((res) => {

      postRequest('/login',params)
        .then((res:any) => {
          // message.success('登录成功');
          const logTime = moment().format('YYYYMMDDHH');
          const info = { logTime, ...res.user, };

          store.commit('login/setUserInfo', info);
          // 登录后进入地图页

          // if (info.regionInfos[0].id === '320125000000' || info.regionInfos[0].id === '410800000000')

          //  fullScreen();

          if (res.user.name === '19999999999') {
            router.push('/logged/account/adminManage');
          } else {
            // 保存用户空气站图标配置数据
            const { pmIconsConfig, } = res.user?.regionInfos[0]?.frontConfig || {};

            Object.keys(pmIconsConfig).forEach((key) => {
              pmIconsConfig[key] = JSON.parse(pmIconsConfig[key]);
            });
            localStorage.setItem('pmIconsConfig', JSON.stringify(pmIconsConfig));
            // 获取登录用户菜单权限，有一张图权限时，默认进入一张图，没有一张图权限时，进入有权限的第一个页面
            axios.get(`${serverIp}/menu/userMenuList`).then(({ data, }) => {
              const menus = data.data?.menu ? data.data?.menu : data.data;

              if (menus) {
                const hasOneMap = menus.findIndex((menu:any) => menu.url === '/logged/mapLogin') > -1;

                if (hasOneMap) {
                  router.push('/logged/mapLogin');

                  return;
                }
                // 第一个非门户页
                const firstMenu = menus.find((item:any) => item.id !== '100');
                let url = '';

                if (firstMenu.children) {
                  url = firstMenu.children[0].url;
                } else {
                  url = firstMenu.url;
                }
                router.push(url);
              }
            });
            // router.push('/logged/mapLogin');
          }
        }).catch((err:any) => {
          message.error(err);
          formRef.value.resetFields();
          change();
        });
    })
    .catch((error: ValidateErrorEntity<FormState>) => {
      // console.log('error', error);
    });
};

const toRegister = () => {
  router.push('/register');
};

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    onSubmit();
  }
});

/**
 * 重置表单
 * @return {void}
 */
const resetForm = () => {
  formRef.value.resetFields();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main",
    style: _normalizeStyle({
  backgroundImage: `url(${_unref(assetsImg).loginBg})`,
    backgroundRepeat: 'no-repeat',
  }),
    "οnlοad": "opener.location.reload()"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "title",
        style: _normalizeStyle({
      backgroundImage: 'url(' + _unref(sysConfig).loginTitleBg + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    })
      }, null, 4),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Form), {
          class: "login-info",
          model: _unref(formState),
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Item), { name: "tel" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  placeholder: "请输入用户名",
                  value: _unref(formState).tel,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formState).tel) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Item), { name: "password" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Password), {
                  placeholder: "请输入密码",
                  value: _unref(formState).password,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formState).password) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", {
          class: "register-btn",
          onClick: toRegister
        }),
        _createVNode(_unref(Button), { onClick: onSubmit }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ], 4))
}
}

})